"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Mar 12 2020
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var ForecastSimulationConflictNodeDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastSimulationConflictNodeDTOConverter, _DataObjectConverter_);

  function ForecastSimulationConflictNodeDTOConverter() {
    _classCallCheck(this, ForecastSimulationConflictNodeDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationConflictNodeDTOConverter).apply(this, arguments));
  }

  return ForecastSimulationConflictNodeDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastSimulationConflictNodeDTOConverter = ForecastSimulationConflictNodeDTOConverter;